import { CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./BMOMemberSearchForm.scss";
import BMOCoverage from "./BMOBasic.png";
import InfoIcon from "@mui/icons-material/Info";
import { Dialog } from "webapp/components";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function BMOMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [vehicleId, setVehicleId] = useState(props.vehicleId || "");
  const [licensePlate, setLicensePlate] = useState(props.licensePlate || "");
  const [last8Vin, setLast8Vin] = useState(props.last8Vin || "");
  const [firstName, setFirstName] = useState(props.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.lastName || props.currState.LastName || "");
  const [coverageTypes, setCoverageTypes] = useState([
    { key: "BMO - Basic", value: "Basic" },
    { key: "BMO - Embedded", value: "Embedded" },
    { key: "BMO - Enhanced", value: "Enhanced" },
    { key: "Not available", value: "I can't find it" },
  ]);

  const [selectedCoverageType, setSelectedCoverageType] = useState(undefined);

  const [moreThanEightVin, setMoreThanEightVin] = useState(false);

  const [openImage, setOpenImage] = useState(false);
  const handleOpenImageDialog = () => {
    devLog("Open image");
    setOpenImage(true);
  };
  const handleCloseImageDialog = () => {
    setOpenImage(false);
  };

  useEffect(() => {
    if (openImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [openImage]);

  const [searchTypes, setSearchTypes] = useState([{ key: "NAME", value: t("description.Name") }]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("NAME");

  useEffect(() => {
    devLog(selectedSearchTypes);
    setFirstName(firstName);
    setLastName(lastName);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        coverageType: selectedCoverageType,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        coverageType: selectedCoverageType,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const vinInputLength = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
      devLog("Vin Length error");
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          {/* <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle
              style={{ color: "white" }}
              variant="dark"
              id="dropdown-basic"
            >
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown> */}

          <div className="searchType">{t("description.Name")}</div>

          {/*Name (first name)*/}
          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="text"
                  // placeholder={t("description.ConfirmCustomerFirstName")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="text"
                  // placeholder={t("description.ConfirmCustomerLastName")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.CoverageType")}:</div>

                <Dropdown className="coverage-dropdown">
                  <Dropdown.Toggle style={{ color: "#0d6ef" }} variant="light" id="dropdown-basic">
                    {selectedCoverageType === undefined ? t("description.CoverageType") : selectedCoverageType}
                  </Dropdown.Toggle>
                  <Dropdown.Menu variant="light">
                    {coverageTypes.map((coverageType) => {
                      return (
                        <Dropdown.Item
                          active={coverageType.key === selectedCoverageType}
                          onClick={(e) => setSelectedCoverageType(coverageType.value)}
                        >
                          {coverageType.value}
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div
                className="group-1"
                onClick={handleOpenImageDialog}
                style={{
                  justifyContent: "center",
                }}
              >
                <InfoIcon style={{ color: "#0078c1" }}></InfoIcon>
                <a className="find-coverage">{t("description.CoverageTypeHint")}</a>
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>

      {openImage && (
        <div className="coverage-modal">
          <div className="modal-wrap">
            <img src={BMOCoverage} alt="" className="cover-img" />
            <div onClick={handleCloseImageDialog} className="close-image-btn">
              {t("description.HelpCallButton2")}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default BMOMemberSearchForm;
